import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import SHOW_COMMENT_ICON from '@tencent/docs-design-resources/icon/desktop/svg/show_comments_light_24.svg';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.SHOW_COMMENT,
    icon: SHOW_COMMENT_ICON,
    content: i18n.t('查看批注'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        tooltip: config.content,
    },
];
